<template>
  <div class="nearest-tour" @click.stop="onClickHandler" :class="classes">
    <div class="nearest-tour__wrap">
      <div class="nearest-tour__text">
        До твоей
        <span>квалификации</span>
        <span class="countdown-label">Осталось:</span>
        <Countdown
          @ticked="$emit('onTick')"
          @stoped="onTimerStoped"
          :endtime="tournament.starts_at"
          divider=""
          typed-nums
        />
      </div>
    </div>
  </div>
</template>

<script>
import Countdown from "@/components/ui/timer/Countdown";

export default {
  components: {
    Countdown
  },

  props: {
    closeDelay: {
      type: [Number, String],
      default: 1000
    },

    tournament: {
      type: Object,
      required: true
    },

    small: Boolean
  },

  computed: {
    delay() {
      return +this.closeDelay || 0;
    },

    classes() {
      return {
        "nearest-tour_small": this.small
      };
    }
  },

  methods: {
    onTimerStoped() {
      setTimeout(() => {
        this.$emit("isDeactivated");
      }, this.delay);
    },

    onClickHandler() {
      const href = this.$router.resolve({
        name: "tournament-info",
        params: {
          tournament_id: this.tournament.id
        }
      }).href;

      this.$emit("clicked", href);
    }
  }
};
</script>

<style lang="scss">
.nearest-tour {
  position: relative;
  border-radius: 100%;
  background: gradient(#fbc33e, #e72f31);
  box-shadow: 0 0 30px rgba(#e72f31, 0.75);
  animation: room-label-pulse 1s infinite;
  overflow: hidden;
  user-select: none;
  cursor: pointer;

  width: 320px;
  height: 320px;
  padding: 10px;

  &:before {
    content: "";
    position: absolute;
    border-radius: inherit;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
  }

  @include breakpoint("xs-only") {
    width: 255px;
    height: 255px;
  }

  &__wrap {
    position: relative;
    border-radius: inherit;
    border: 4px solid #e72f31;
    width: 100%;
    height: 100%;
    background: radial-gradient(
      144.17px at 50% 51.82%,
      #8d1111 0%,
      #1e2135 100%
    );

    &:before {
      content: "";
      position: absolute;
      border-radius: inherit;
      width: 100%;
      height: 100%;
      left: 0;
      top: 0;
      background: url("~@/assets/img/match-ready-bg.png") no-repeat center
        center #1e2135;
      transition: 0.2s;

      .nearest-tour:hover & {
        // transform: scale(0.95);
        box-shadow: inset 0 0 10px 0 #000;
      }

      .nearest-tour:active & {
        // transform: scale(0.9);
        box-shadow: inset 0 0 30px 0 #000;
      }
    }
  }

  &__text {
    position: relative;
    transform-origin: center top;
    transition: 0.2s;

    font-weight: bold;
    font-size: 15px;
    line-height: 24px;
    text-align: center;
    letter-spacing: -0.03em;
    text-transform: uppercase;

    color: #fbc33e;

    text-shadow: 0px 3px 4px rgba(0, 0, 0, 0.75);

    span {
      font-weight: 900;
      font-size: 18px;
      line-height: 24px;
      color: #ffffff;
      display: block;
    }

    .nearest-tour:hover & {
      transform: scale(0.95);
    }

    .nearest-tour:active & {
      transform: scale(0.9);
    }

    top: 28%;
    left: 0;
    width: 100%;

    // @include breakpoint("xs-only") {
    //   font-size: 38px;
    //   line-height: 36px;
    // }
  }

  &_small {
    width: 200px;
    height: 200px;
    padding: 5px;

    &.nearest-tour {
      animation: room-label-small-pulse 1s infinite;
    }

    .nearest-tour__wrap {
      border: 2px solid #e72f31;

      &:before {
        background-size: 200px 200px;
      }
    }

    // .nearest-tour__text {
    //   font-size: 25px;
    //   line-height: 24px;

    //   @include breakpoint("xs-only") {
    //     font-size: 25px;
    //     line-height: 24px;
    //   }
    // }
  }

  .countdown .day,
  .countdown .hour,
  .countdown .min,
  .countdown .sec {
    padding: 0px;
    background: none;
    min-height: 25px;
    align-items: baseline;
  }

  .countdown__divider {
    padding: 0px 4px;

    &:first-child,
    &:last-child {
      display: none;
    }
  }

  .countdown-label {
    font-size: 13px;
    line-height: 1;
    text-align: center;
    letter-spacing: 0;
    color: #ffffff;
    text-transform: none;
    text-shadow: 0px 3px 4px rgba(0, 0, 0, 0.5);
    margin: 8px 0 2px;
  }

  .countdown {
    .number {
      font-weight: bold;
      font-size: 20px;
      line-height: 107%;
      /* or 24px */
      text-align: center;
      color: #fbc33e;

      text-shadow: 0px 3px 4px rgba(0, 0, 0, 0.5);
    }
    .number-type {
      margin-left: 4px;
      font-weight: bold;
      font-size: 14px;
      line-height: 107%;
      /* or 17px */
      text-align: center;
      letter-spacing: -0.05em;

      color: #fbc33e;

      text-shadow: 0px 3px 4px rgba(0, 0, 0, 0.5);
      text-transform: none;
    }
  }
}
</style>
